<template>
  <div v-if="loaderCount > 0" class="loader">
    <div class="loader-inner">
      <div class="loader-animated">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
import Store from '@/stores/store'

export default {
  computed: {
    loaderCount: () => Store.getters.loaderCount
  }
}
</script>

<style lang="scss">
@keyframes loader-animated {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.loader {
  background: rgba(#ffffff, 0.9);
  height: 100%;
  left: 0;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: 9999;

  // Overlay a parent element instead of the viewport
  .o-app & {
    position: absolute;
  }

  &-inner {
    background: none;
    bottom: 0;
    display: block;
    height: 200px;
    left: 0;
    margin: auto;
    overflow: hidden;
    position: absolute;
    right: 0;
    top: 0;
    width: 200px;
  }

  &-animated {
    width: 100%;
    height: 100%;
    position: relative;
    transform: translateZ(0) scale(1);
    backface-visibility: hidden;
    transform-origin: 0 0;

    div {
      box-sizing: content-box;
      left: 94px;
      top: 48px;
      position: absolute;
      animation: loader-animated linear 1s infinite;
      background: #7667a7;
      width: 12px;
      height: 24px;
      border-radius: 6px / 12px;
      transform-origin: 6px 52px;

      &:nth-child(1) {
        transform: rotate(0deg);
        animation-delay: -0.9166666666666666s;
        background: #7667a7;
      }

      &:nth-child(2) {
        transform: rotate(30deg);
        animation-delay: -0.8333333333333334s;
        background: #2da780;
      }

      &:nth-child(3) {
        transform: rotate(60deg);
        animation-delay: -0.75s;
        background: #edb539;
      }

      &:nth-child(4) {
        transform: rotate(90deg);
        animation-delay: -0.6666666666666666s;
        background: #ea5244;
      }

      &:nth-child(5) {
        transform: rotate(120deg);
        animation-delay: -0.5833333333333334s;
        background: #93d1d5;
      }

      &:nth-child(6) {
        transform: rotate(150deg);
        animation-delay: -0.5s;
        background: #4e5251;
      }

      &:nth-child(7) {
        transform: rotate(180deg);
        animation-delay: -0.4166666666666667s;
        background: #7667a7;
      }

      &:nth-child(8) {
        transform: rotate(210deg);
        animation-delay: -0.3333333333333333s;
        background: #2da780;
      }

      &:nth-child(9) {
        transform: rotate(240deg);
        animation-delay: -0.25s;
        background: #7667a7;
      }

      &:nth-child(10) {
        transform: rotate(270deg);
        animation-delay: -0.16666666666666666s;
        background: #2da780;
      }

      &:nth-child(11) {
        transform: rotate(300deg);
        animation-delay: -0.08333333333333333s;
        background: #edb539;
      }

      &:nth-child(12) {
        transform: rotate(330deg);
        animation-delay: 0s;
        background: #ea5244;
      }
    }
  }
}
</style>
